/**
 * Created by berkin on 24/05/16.
 */
export default {
	register: {
		order: 0,
		title: 'Register', // get it from i18n text
		back: null,
		skip: null,
		close: '/',
		nextButtonTitle: '',
		action: null,
		url: '/register',
		closeClass: 'slide-out-down',
		openClass: 'slide-in-up'
	},
	register_details: {
		order: 1,
		title: 'Register Details', // get it from i18n text
		back: '/register',
		skip: null,
		close: null,
		nextButtonTitle: '',
		action: null,
		url: '/register/details',
		closeClass: 'slide-out-down',
		openClass: 'slide-in-up'
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/register/config.js